import React from 'react'
import { MainContainer, Content,
  SlideViewport, SlideTrack, SlidePanel
 } from '../HomepageStarterEmail/styled'
import { StyledLogo } from '../styled'
import { ControllerInput } from '../../shared/Input/ControllerInput'
import { useSelector } from 'react-redux'
import { useAllowedCountries } from '../../../hooks/useRoutes'
import { useInitUser } from '../../../hooks/useUser'
import { useGetStarted } from '../../../hooks/useUser'
import { useTranslation } from 'react-i18next'
import { characters } from '../../../constants/form'
import { trimUpperCase } from '../../../helpers/shared'
import { languagueEs } from '../../../constants/base'
import { envSetting } from '../../../constants/envSetting'
import { CheckLink } from '../../shared/simple/CheckLink'
import { Button } from '../../shared/simple/Button'
import { RouterLink } from '../../shared/simple/RouterLink'
import { routes } from '../../../constants/routes'
import { Label } from '../../shared/simple/Label'
import { useTheme } from '@mui/material'
import { useMediaQuery } from '@mui/material'
import SlideCaptchaModal from '../../shared/slide-captcha-modal/SlideCaptchaModal'
import { LoaderSpinner } from '../../shared/simple/LoaderSpinner'

const AltGetStarted = () => {
  const { t } = useTranslation();
  const { allowed } = useAllowedCountries();
  const { selectedProduct } = useSelector(state => state.user);
  const { actualLanguage } = useSelector(state => state.base);
  const {
    appOrigin,
    isSlideModalOpen,
    loading,
    onSubmit,
    setIsSlideModalOpen,
    values
  } = useInitUser(allowed);
  const { errors, handleSubmit, onSignUp, register, methods } = useGetStarted();
  const responsiveTheme = useTheme();
  const isMobile = useMediaQuery(responsiveTheme.breakpoints.down('sm'));

  const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '2px',
    marginBotton: '0px',
    width: 'fit-content',
    textAlign: 'left',
    position: 'static'
  }; 

  return (
    <MainContainer
      customFlexDirection='column'
      isMobile={isMobile}
    >
      <StyledLogo
        className="d-xs-block d-md-none"
        rel="preload"
        src={ selectedProduct?.image_ads }
        customPosition={'static'}
        customHeight={80}
      />
      <Content
        customWidth='500px'
      >
        <form
          onSubmit={ handleSubmit(onSubmit) }
        >
          <h1 className="pb-4">{ t("getStarted.getStarted") }</h1>
          <ControllerInput
            autoComplete="off"
            disabled={ loading }
            isRequiredInput={ true }
            label={ t("common.username") }
            message={ errors.username?.message }
            name={ register("username").name }
            control={methods?.control}              
            tooltipText={ t("getStarted.usernameRequired", { min: 6 }) }
            type="text"
            labelColor='white'
            altErrorStyle={altErrorMessageStyle}
            groupClassName='mb-2'
          />
          <ControllerInput
            autoComplete="off"
            disabled={ loading }
            isRequiredInput={ true }
            label={ t("common.password") }
            message={ errors.password?.message }
            name={ register("password").name }
            control={methods?.control}              
            tooltipText={ t("getStarted.passwordRequired", { min: 8, characters }) }
            type="password"
            labelColor='white'
            altErrorStyle={altErrorMessageStyle}
            groupClassName='mb-2'
          />
          <CheckLink
            color="white"
            href={ (trimUpperCase(actualLanguage) === languagueEs) ? envSetting.termsConditionsEs : envSetting.termsConditionsEn }
            message={ errors.termservice?.message }
            params={{ company: envSetting.companyName }}
            register={ register("termservice") }
            translation="getStarted.termService"
            altErrorStyle={altErrorMessageStyle}
            type="checkbox"
          />
          {loading
            ? (
              <LoaderSpinner />
            ) : (
              <Button
                className="btn mb-0"
                disabled={ loading }
                color="first"
                type="submit"
                name="btn_get_started"
              >
                { t("common.continue") }
              </Button>
            )
          }
          <Label className="wantText" color='white'>
            { t("getStarted.signUp") }&nbsp;
            {!loading && (
              <RouterLink
                className="p-0 col-12"
                to={ routes.login(appOrigin) }
                color="third"
                disabled={ loading }
              >
                { t("login.buttonLogIn") }
              </RouterLink>
            )}
          </Label>
        </form>
        <SlideCaptchaModal
          isOpen={ isSlideModalOpen }
          onRequestClose={ () => setIsSlideModalOpen(false) }
          onSuccess={ () => onSignUp(values) }
        />
      </Content>
    </MainContainer>
  )
}

export default AltGetStarted